/** The local draft of a card being composed in Advanced Create (nothing exists on the server). */
import type { NewCardBlock } from '@/entities/board';

export type DraftBlock =
  | { key: string; kind: 'markdown'; text: string }
  | { key: string; kind: 'checklist'; title: string; items: string[] };

let counter = 0;
export const blockKey = () => `block-${String(++counter)}`;

export const newMarkdownBlock = (): DraftBlock => ({ key: blockKey(), kind: 'markdown', text: '' });
export const newChecklistBlock = (): DraftBlock => ({
  key: blockKey(),
  kind: 'checklist',
  title: '',
  items: [],
});

/**
 * What the draft sends: empty Markdown blocks and blank checklist items are dropped (an empty
 * block is not content), a checklist keeps its title even without items.
 */
export function blocksPayload(blocks: readonly DraftBlock[]): NewCardBlock[] {
  return blocks.flatMap((block): NewCardBlock[] => {
    if (block.kind === 'markdown') {
      return block.text.trim() ? [{ markdown_text: block.text }] : [];
    }
    const items = block.items.map((item) => item.trim()).filter(Boolean);
    return [{ checklist: { title: block.title.trim() || null, items } }];
  });
}

export function moveBlock(
  blocks: readonly DraftBlock[],
  key: string,
  direction: -1 | 1,
): DraftBlock[] {
  const index = blocks.findIndex((block) => block.key === key);
  const target = index + direction;
  if (index === -1 || target < 0 || target >= blocks.length) return [...blocks];
  const next = [...blocks];
  const [moved] = next.splice(index, 1);
  if (moved) next.splice(target, 0, moved);
  return next;
}
